export default __webpack_public_path__ + "static/media/bellefonte-header.3d228d57.jpg";